import styled from '@emotion/styled';

export const SContainer = styled.div`
  display: flex;
  justify-content: space-between;
  .custom-ant-typography {
    .ant-typography-copy {
      color: rgba(0, 0, 0, 0.45);
      &:hover,
      &:active {
        color: #000000;
      }
    }
  }
`;
